module.exports = __webpack_public_path__ + "static/media/all-new-electronics.ed5f364c.png";